import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';

const VideoListPage = () => {
  const { categoryName } = useParams();
  const [searchTerm, setSearchTerm] = useState('');
  const [videos, setVideos] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchVideos = async () => {
        setIsLoading(true);
        setError(null);
        try {
            const response = await axios.get(`/api/videos/summary_list_cat/${categoryName}`);
            setVideos(response.data);
        } catch (err) {
            setError("Failed to load videos for this category.");
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    };
    fetchVideos();
  }, [categoryName]);

  const filteredVideos = videos.filter(video =>
    video.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div>
      <div className="search-bar-container">
        <span className="material-icons search-icon">search</span>
        <input
          type="text"
          placeholder={`Search in ${categoryName}...`}
          className="search-input"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      {isLoading && <p>Loading videos...</p>}
      {error && <p className="error-message">{error}</p>}

      <div className="content-list">
        {!isLoading && !error && (
          filteredVideos.length > 0 ? (
            filteredVideos.map((item) => (
              <Link to={`/videos/${item.id}`} key={item.id} className="content-card">
                <img src={item.thumbnail_url} alt={item.title} className="content-card-thumbnail" />
                <div className="content-card-body">
                  <h3 className="content-card-title">{item.title}</h3>
                  <p className="content-card-description">{item.category}</p>
                </div>
              </Link>
            ))
          ) : (
            <p>No videos found in this category.</p>
          )
        )}
      </div>
    </div>
  );
};

export default VideoListPage;
